/**
 * 場後結算 · 已入帳移動（P1-10）
 *
 * 確認結算之後，貨由 `roadshow:<單號>` 出三筆（`decisions/011`）：
 * 賣出 `SALE`／剩貨 `TRANSFER`／損壞 `ADJUST`（全部落點見 `toLoc`）。
 * ⚠️ 移動**只由後端** `appendMovement()` 寫（append-only）—— 本檔純顯示。
 */
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { btnGhost, card, hint as hintStyle } from '@coeldery/ui-kit';
import type { ReconcileMovement } from '../lib/api';

const TYPE_KEY: Record<string, string> = {
  SALE: 'recon.movementSale',
  TRANSFER: 'recon.movementTransfer',
  ADJUST: 'recon.movementAdjust',
};

export default function ReconcileMovements({ movements }: { movements: ReconcileMovement[] }) {
  const { t } = useTranslation();
  return (
    <section style={{ ...card, padding: '16px', marginTop: '12px' }}>
      <h3 style={{ margin: '0 0 6px', fontSize: '16px', fontWeight: 800 }}>{t('recon.movements')}</h3>
      {movements.length === 0 && <p style={hintStyle}>{t('recon.movementsEmpty')}</p>}
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {movements.map((m) => (
          <li key={m.id} style={{ padding: '8px 0', borderTop: '1px solid var(--color-divider)' }}>
            <strong>{t(TYPE_KEY[m.type] ?? 'recon.movementTransfer')}</strong>
            <span style={hintStyle}>
              {' '}
              {m.itemName} · {m.cartons} {t('recon.cartons')}
              {m.units > 0 ? ` + ${m.units} ${t('recon.units')}` : ''} · cbm {m.cbm}
            </span>
            <p style={hintStyle}>
              {m.fromLoc} → {m.toLoc}
            </p>
            {m.note && <p style={hintStyle}>{m.note}</p>}
          </li>
        ))}
      </ul>
      <Link to="/movements" style={{ ...btnGhost, display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }}>
        {t('recon.viewLedger')}
      </Link>
    </section>
  );
}
